import * as z from "zod";

import { idSchema, surrealRecordSchema } from "./surreal-record";

export const boardMeetingCommentSchema = surrealRecordSchema.extend({
  content: idSchema,
  comment: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type BoardMeetingComment = z.infer<typeof boardMeetingCommentSchema>;
